import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const AllCompetitionSubjectiveExamPricing = () => {
  const [competitions, setCompetitions] = useState([]);
  const [competitionsId, setCompetitionsId] = useState();
  const [data,setData]=useState([])

  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const handleGoBack = () => {
    navigate("/subjective-exam-pricing");
  };
  const handleAddPrice = () => {
    navigate(
      "/subjective-exam-pricing/add-competition-subjective-exam-pricing"
    );
  };
  const handleViewAllPrice = () => {
    navigate(
      "/subjective-exam-pricing/all-competition-subjective-exam-pricing"
    );
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/competitions`)
      .then((response) => {
        const examCategoriesData = response.data?.data || [];
        setCompetitions(examCategoriesData);
      })
      .catch((error) => console.log(error));
  }, []);

  

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .get(`${API_BASE_URL}/pricing/subjective-exam?competitionId=${competitionsId}`,{
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result?.data?.data);
        setData(result?.data?.data)
         
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div id="exam-competitive-notes-inner-wrapper">
        <div className="competitive-main-header">
          <div className="competitive-header-div">
            <h5>Competitive Subjective Exam Pricing</h5>
            <div className="competitive-btn-group">
              <button
                className="addNewCompetitiveNoteBtn"
                onClick={handleAddPrice}
              >
                + Add Price
              </button>
              <button
                className="viewAllCompetitiveNotesBtn"
                onClick={handleViewAllPrice}
              >
                All Price
              </button>
            </div>
          </div>

          <div className="competitive-form-container" id="form">
            <form
              onSubmit={handleSubmit}
              className="competitive-note-detail-form"
            >
              <div className="new-chapter-form-group">
                <label className="new-chapter-label">Exam Category</label>
                <select
                  className="new-chapter-dropdown"
                  value={competitionsId}
                  onChange={(e) => setCompetitionsId(e.target.value)}
                  required
                >
                  <option value="">-Select Category-</option>
                  {competitions.map((examCategory, idx) => (
                    <option key={idx} value={examCategory._id}>
                      {examCategory.examCategory}
                    </option>
                  ))}
                </select>
              </div>
              <div className="competitive-form-btns">
                <button className="competitive-btn-save" type="submit">
                  Seacrh
                </button>
              </div>
            </form>

            <table className="table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Exam Category</th>
             
              <th>Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={item?._id}>
                <td>{index + 1} </td>
                <td>{item?.competitionId?.examCategory} </td>
               
                <td> ₹{item?.price} </td>
                <td
                  onClick={() => {
                    navigate(
                      `/subjective-exam-pricing/edit-competition-subjective-exam-pricing/${item?._id}`,
                      {
                        state: {
                          dataItem: item,
                        },
                      },
                    );
                  }}
                >
                  Edit{" "}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllCompetitionSubjectiveExamPricing;
